import CDNImage from '@/components/ui/CDNImage';
import { Page_Pagebuilder_Blocks_Image } from '@/graphql/generated/graphql';
import { m } from 'motion/react';
import { containerVariants, viewPort } from 'utils/framer';
import { getContainerClass } from 'utils/helpers';

const ImageBlock = ({
  blockId,
  containerWidth,
  image,
  imageMobile,
  video,
  videoMobile,
  videoHasControls,
}: Page_Pagebuilder_Blocks_Image) => {
  return (
    <section id={blockId ?? undefined} className="w-full my-14 lg:my-24">
      <m.div
        initial="hidden"
        whileInView="visible"
        viewport={viewPort}
        variants={containerVariants}
        className={`w-full ${(video && video.mediaItemUrl) || (videoMobile && videoMobile.mediaItemUrl) ? 'w-full' : getContainerClass(containerWidth)}`}
      >
        {video && video.mediaItemUrl ? (
          <>
            <video
              autoPlay
              muted
              loop
              playsInline
              controls={videoHasControls}
              preload="metadata"
              className={`h-full w-full object-cover ${videoMobile && videoMobile.mediaItemUrl ? 'hidden lg:block' : 'block'}`}
            >
              <source src={video.mediaItemUrl} />
            </video>
            {videoMobile && videoMobile.mediaItemUrl ? (
              <video
                autoPlay
                muted
                loop
                playsInline
                controls={videoHasControls}
                preload="metadata"
                className="block h-full w-full object-cover lg:hidden"
              >
                <source src={videoMobile.mediaItemUrl} />
              </video>
            ) : null}
          </>
        ) : image && image.sourceUrl ? (
          <>
            <CDNImage
              src={image.sourceUrl || ''}
              alt={image.altText || ''}
              width={image.mediaDetails.width || 0}
              height={image.mediaDetails.height || 0}
              sizes="(max-width: 1024px) 100vw, 100vw"
              srcSet={image.srcSet || ''}
              className={`h-full w-full object-cover ${imageMobile ? 'hidden lg:block' : 'block'}`}
              loading="eager"
            />
            {imageMobile && imageMobile.sourceUrl ? (
              <CDNImage
                src={imageMobile.sourceUrl || ''}
                alt={imageMobile.altText || ''}
                width={imageMobile.mediaDetails.width || 0}
                height={imageMobile.mediaDetails.height || 0}
                sizes="(max-width: 1024px) 100vw, 100vw"
                srcSet={imageMobile.srcSet || ''}
                className="block h-full w-full object-cover lg:hidden"
                loading="eager"
              />
            ) : null}
          </>
        ) : null}
      </m.div>
    </section>
  );
};

export default ImageBlock;
